import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
  private readonly urlBackEnd: any;

  constructor(private localStorage: LocalStorageService, private sessionStorage: SessionStorageService) {
    this.urlBackEnd = environment.urlBackEnd;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const random = Math.floor(Math.random() * 1000);
    if (request.body) {
      request.body.requestId  = request.body.requestId || Date.now() + random;
    }
    const params: any = request.params;
    params.map = params.map || new Map();
    if (params.map) {
      params.map.set('requestId', [Date.now() + random]);
    }
    let token = this.localStorage.retrieve('TOKEN') || this.sessionStorage.retrieve('TOKEN');
    const object: any = {
      setHeaders: {
        'accept-language': 'vi',
      },
      withCredentials: true
    };
    if (token) {
      object.setHeaders.Authorization = token;
    }
    request = request.clone(object);
    return next.handle(request);
  }
}
